// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.GraphicalDataSourceEdge
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { Message } from "abweb/dto/Message";
import { GraphicalDataSourceNode } from "abweb/dto/gds/GraphicalDataSourceNode";
import { GraphicalDataSourceObject } from "abweb/dto/gds/GraphicalDataSourceObject";
import { NamedDataSourceRecordReference } from "abweb/dto/gds/NamedDataSourceRecordReference";
import { Point } from "abweb/dto/gds/Point";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class GraphicalDataSourceEdgeBase extends GraphicalDataSourceObject {
  /** Do NOT invoke directly, instead use strongly typed createGraphicalDataSourceEdgeBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.GraphicalDataSourceEdge";
  }
  initFromJson(json, deserializeContext) {
    this.initGraphicalDataSourceEdge(TSOGUtils.decodeObject(json.dataSourceRecordReference, NamedDataSourceRecordReference, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "dataSourceRecordReference")), json.id != null ? json.id : null, json.messages != null ? TSOGUtils.decodeObjectArray(json.messages, Message, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "messages")) : null, json.state != null ? DataSourceState.fromJson(json.state) : null, json.styleClasses != null ? json.styleClasses : null, json.viewType != null ? json.viewType : null, TSOGUtils.decodeObject(json.dst, GraphicalDataSourceNode, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "dst")), TSOGUtils.decodeObject(json.midpoint, Point, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "midpoint")), json.points != null ? TSOGUtils.decodeObjectArray(json.points, Point, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "points")) : null, TSOGUtils.decodeObject(json.src, GraphicalDataSourceNode, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "src")));
  }
  initGraphicalDataSourceEdge(dataSourceRecordReference, id, messages, state, styleClasses, viewType, dst, midpoint, points, src) {
    this.initGraphicalDataSourceObject(dataSourceRecordReference, id, messages, state, styleClasses, viewType);
    this._dst = dst;
    this._midpoint = midpoint;
    this._points = points;
    this._src = src;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["dst"] = TSOGUtils.toTSOGNativeObject(this._dst, serializeContext);
    if (this._midpoint != null) {
      retVal["midpoint"] = TSOGUtils.toTSOGNativeObject(this._midpoint, serializeContext);
    }
    retVal["points"] = TSOGUtils.toTSOGArray(this._points, serializeContext);
    retVal["src"] = TSOGUtils.toTSOGNativeObject(this._src, serializeContext);
    return retVal;
  }
  get dst() {
    return this._dst;
  }
  set dst(value) {
    this._dst = value;
  }
  get midpoint() {
    return this._midpoint;
  }
  set midpoint(value) {
    this._midpoint = value;
  }
  get points() {
    return this._points;
  }
  set points(value) {
    this._points = value;
  }
  get src() {
    return this._src;
  }
  set src(value) {
    this._src = value;
  }
}
//# sourceMappingURL=GraphicalDataSourceEdgeBase.js.map
